import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MessageDialog } from '../models/message-dialog';
import { MessageDialogComponent } from '../components/message-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class MessageDialogService {

  constructor(private dialog: MatDialog) { }

  show(title: string, message: string) : void{
    const confirmDialog: MessageDialog = {
      title: title,
      message: message,
    }
    this.dialog.open(MessageDialogComponent, {
      data: confirmDialog,
      autoFocus: true,
      disableClose: true
    });
  }
}
